var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.screen == '3') ? _c('RVPPrintLabelReviewv2', {
    attrs: {
      "propsParam": _vm.propsParameter
    }
  }) : (_vm.screen == '2') ? _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("InScan RVP Shipments")]), _vm._v(" "), _c('div', {
    staticClass: "stepper-wrapper"
  }, [_c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step done"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Print Sticker")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "step active"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("2")]), _vm._v(" "), (_vm.actionStatus != 'linkingpending') ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Inscan Flyer and AWB")]) : _vm._e(), _vm._v(" "), (_vm.actionStatus == 'linkingpending') ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Varify Flyer and AWB")]) : _vm._e()]), _vm._v(" "), (_vm.actionStatus != 'linkingpending') ? _c('div', {
    staticClass: "line"
  }) : _vm._e(), _vm._v(" "), (_vm.actionStatus != 'linkingpending') ? _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Review")])]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [(_vm.actionStatus != 'linkingpending') ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.formLoading
    },
    on: {
      "update:active": function($event) {
        _vm.formLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm('form-1')
      },
      "reset": _vm.reset
    }
  }, [_c('div', {
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Packaging Type: ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.weightType')
    },
    attrs: {
      "options": _vm.weightTypeOptions,
      "selected-option": _vm.selectedWeight,
      "placeholder": "--Not Mandatory--",
      "name": "weightType"
    },
    on: {
      "select": _vm.SelectWeight
    },
    model: {
      value: (_vm.weightType),
      callback: function($$v) {
        _vm.weightType = $$v
      },
      expression: "weightType"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openDimentionWeightTab),
      expression: "openDimentionWeightTab"
    }],
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Lenght(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-alt'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Length')
    },
    attrs: {
      "type": "text",
      "id": "lengthid",
      "placeholder": "Enter Length",
      "name": "Length"
    },
    model: {
      value: (_vm.length),
      callback: function($$v) {
        _vm.length = $$v
      },
      expression: "length"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Length')),
      expression: "errors.has('form-1.Length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Length')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Breadth(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-h'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Breadth')
    },
    attrs: {
      "type": "text",
      "id": "breadthid",
      "placeholder": "Enter Breadth",
      "name": "Breadth"
    },
    model: {
      value: (_vm.breadth),
      callback: function($$v) {
        _vm.breadth = $$v
      },
      expression: "breadth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Breadth')),
      expression: "errors.has('form-1.Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Breadth')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Height(cm):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-v'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Height')
    },
    attrs: {
      "type": "text",
      "id": "heightid",
      "placeholder": "Enter Height",
      "name": "Height"
    },
    model: {
      value: (_vm.height),
      callback: function($$v) {
        _vm.height = $$v
      },
      expression: "height"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Height')),
      expression: "errors.has('form-1.Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Height')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Physical Weight(kg):")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.onDimentionTabValidation == true ? {
        required: true,
        regex: /^[0-9]*\.?[0-9]*\.?[0-9]*$/
      } : ''),
      expression: "onDimentionTabValidation == true ? {required:true,regex:/^[0-9]*\\.?[0-9]*\\.?[0-9]*$/} : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.Physical_Weight')
    },
    attrs: {
      "type": "text",
      "id": "physicalWeightId",
      "placeholder": "Enter Physical Weight",
      "maxlength": 6,
      "name": "Physical_Weight"
    },
    on: {
      "keyup": _vm.checkPW
    },
    model: {
      value: (_vm.physicalWeight),
      callback: function($$v) {
        _vm.physicalWeight = $$v
      },
      expression: "physicalWeight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Physical_Weight')),
      expression: "errors.has('form-1.Physical_Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Physical_Weight')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPWcheckBox),
      expression: "showPWcheckBox"
    }],
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmPhyWt),
      expression: "isConfirmPhyWt"
    }],
    staticClass: "status mr-2 checkboxLarge status-radio",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isConfirmPhyWt",
      "id": "isConfirmPhyWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmPhyWt) ? _vm._i(_vm.isConfirmPhyWt, "") > -1 : (_vm.isConfirmPhyWt)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isConfirmPhyWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmPhyWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmPhyWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmPhyWt = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_vm._v("Confirm Physical Weight:")])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVWcheckBox),
      expression: "showVWcheckBox"
    }],
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isConfirmVolWt),
      expression: "isConfirmVolWt"
    }],
    staticClass: "status mr-2 checkboxLarge status-radio",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isConfirmVolWt",
      "id": "isConfirmVolWt"
    },
    domProps: {
      "checked": Array.isArray(_vm.isConfirmVolWt) ? _vm._i(_vm.isConfirmVolWt, "") > -1 : (_vm.isConfirmVolWt)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isConfirmVolWt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isConfirmVolWt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isConfirmVolWt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isConfirmVolWt = $$c
        }
      }
    }
  }), _vm._v(" Confirm Volumetric\n                          Weight:\n                        ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form group-row"
  }, [(_vm.isShipInputBoxShown) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipment barcode :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader,
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentBarcode),
      expression: "shipmentBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearShipmentBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipmentBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearShipmentBarcode",
      "placeholder": "Scan Shipment Barcode",
      "name": "shipmentBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentBarcode)
    },
    on: {
      "keydown": _vm.handleShipmentKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentBarcode = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyerBarcode),
      expression: "flyerBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearFlyerBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.flyerBarcode')
    },
    attrs: {
      "type": "text",
      "id": "clearFlyerBarcode",
      "placeholder": "Scan Flyer Barcode",
      "name": "flyerBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.flyerBarcode)
    },
    on: {
      "keydown": _vm.handleFlyerKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyerBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.flyerBarcode')),
      expression: "errors.has('form-1.flyerBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.flyerBarcode')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "disabled": (_vm.IsPrinterAvailable && !(_vm.flyerBarcode && _vm.shipmentBarcode)) || (!_vm.IsPrinterAvailable && (!_vm.flyerBarcode)) || _vm.inscanBtnDisabled
    }
  }, [_vm._v("\n                          Inscan")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetAll
    }
  }, [_vm._v(" Reset")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1' && _vm.rePrintCount > 0),
      expression: "selected == '1' && rePrintCount > 0"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reprintStricker
    }
  }, [_vm._v("Reprint Sticker")])])], 1)], 1)])])], 1) : _c('div', {
    staticClass: "col-md-5"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.formLoading
    },
    on: {
      "update:active": function($event) {
        _vm.formLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitFormLinking('form-1')
      },
      "reset": _vm.reset
    }
  }, [_c('div', {
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipment Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader,
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentBarcode),
      expression: "shipmentBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearShipmentBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipmentBarcode')
    },
    attrs: {
      "type": "text",
      "id": "linkingShipmentBarcode",
      "placeholder": "Scan Shipment Barcode",
      "name": "shipmentBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentBarcode)
    },
    on: {
      "keypress": _vm.changeTabPosition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shipmentBarcode')),
      expression: "errors.has('form-1.shipmentBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.shipmentBarcode')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    ref: "clearFlyerBarcode",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.flyerBarcode')
    },
    attrs: {
      "type": "text",
      "id": "linkingflyerBarcode",
      "placeholder": "Scan Flyer Barcode",
      "name": "flyerBarcode",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.flyerBarcode),
      callback: function($$v) {
        _vm.flyerBarcode = $$v
      },
      expression: "flyerBarcode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.flyerBarcode')),
      expression: "errors.has('form-1.flyerBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.flyerBarcode')))])], 1)], 1), _vm._v(" "), (_vm.IsReverseWeightCaptured == false) ? _c('span', {
    staticClass: "col-sm-7 ml-3",
    staticStyle: {
      "border": "1px solid",
      "padding": "10px",
      "font-weight": "600"
    },
    attrs: {
      "show": "",
      "variant": "default"
    }
  }, [_vm._v("\n                      Weighing Required after linking:    ✅\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.IsReverseWeightCaptured == true) ? _c('span', {
    staticClass: "col-sm-5 ml-3",
    staticStyle: {
      "border": "1px solid",
      "padding": "10px",
      "font-weight": "600"
    },
    attrs: {
      "show": "",
      "variant": "default"
    }
  }, [_vm._v("\n                      Weighing Required:   ❌\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "disabled": (_vm.IsPrinterAvailable && !(_vm.flyerBarcode && _vm.shipmentBarcode)) || (!_vm.IsPrinterAvailable && (!_vm.flyerBarcode)) || _vm.inscanBtnDisabled
    }
  }, [_vm._v("\n                          Verify and linking")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetAll
    }
  }, [_vm._v(" Reset")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1' && _vm.rePrintCount > 0),
      expression: "selected == '1' && rePrintCount > 0"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reprintStricker
    }
  }, [_vm._v("Reprint Sticker")])])], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.openModelPendingShipmentList(_vm.modalType)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "RVP Pending For InScan",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('RVP')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoading,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "width": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('RVP')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload RVP InScan Shipments"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.total) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_id')
    },
    attrs: {
      "type": "text",
      "id": "clearSearchField",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_id"
    },
    model: {
      value: (_vm.searchByShippingId),
      callback: function($$v) {
        _vm.searchByShippingId = $$v
      },
      expression: "searchByShippingId"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getPendingShipmentListForPickupDone
    }
  }, [_vm._v(" Search")])])], 1)], 1)])]), _vm._v(" "), _c('pending-InscanRVP', {
    attrs: {
      "rvpInscanPendingShipments": _vm.pendingShipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending For Return (RVP)",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTab('Shortage')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoading,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "width": "auto",
      "overflow-x": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.refresh('Shortage')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalShipments) + "\n                              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_ID')
    },
    attrs: {
      "type": "text",
      "id": "clearShortageSearchField",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_ID"
    },
    model: {
      value: (_vm.searchByShippingIdForShortage),
      callback: function($$v) {
        _vm.searchByShippingIdForShortage = $$v
      },
      expression: "searchByShippingIdForShortage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShortageShipmentList
    }
  }, [_vm._v(" Search")])])], 1)], 1)])]), _vm._v(" "), _c('shortage-shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shortageShipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShortagePaginate),
      expression: "showShortagePaginate"
    }],
    attrs: {
      "page-count": _vm.pageCountForShortage,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataForShortage,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "RVP Pending For InScan"
    },
    model: {
      value: (_vm.pendingShipmentModel),
      callback: function($$v) {
        _vm.pendingShipmentModel = $$v
      },
      expression: "pendingShipmentModel"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingShipmentLoadingMdl,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingShipmentLoadingMdl = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP Pending For InScan")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('RVPMdl')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row mb-2 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "margin-top": "0.2em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    on: {
      "click": function($event) {
        return _vm.refresh('RVPModal')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "1em",
      "margin-top": "0.2em"
    }
  }, [_vm._v("Count : " + _vm._s(_vm.total3))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shipping_Id')
    },
    attrs: {
      "type": "text",
      "id": "clearSearchFieldMdl",
      "placeholder": "Search By Shipping id",
      "name": "Shipping_Id"
    },
    model: {
      value: (_vm.searchByShippingIdMdl),
      callback: function($$v) {
        _vm.searchByShippingIdMdl = $$v
      },
      expression: "searchByShippingIdMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShipmentbyShippingIdMdl
    }
  }, [_vm._v(" Search")])])], 1)], 1)]), _vm._v(" "), _c('pending-InscanRVP', {
    attrs: {
      "rvpInscanPendingShipments": _vm.pendingShipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('RVPMdl')
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Shortage Shipment List"
    },
    model: {
      value: (_vm.shortageShipmentMdl),
      callback: function($$v) {
        _vm.shortageShipmentMdl = $$v
      },
      expression: "shortageShipmentMdl"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isShortageShipmentLoadingMdl,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isShortageShipmentLoadingMdl = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "document"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending For Return (RVP)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "name": "button",
      "data-dismiss": "modal",
      "area-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('ShortageMdl')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row mb-2 justify-content-end"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "margin-top": "0.2em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    on: {
      "click": function($event) {
        return _vm.refresh('SSMdl')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "1em",
      "margin-top": "0.2em"
    }
  }, [_vm._v("Count :\n                      " + _vm._s(_vm.totalShortageShipMDl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "ShortageShippingMdl",
      "placeholder": "Enter Shipping Id",
      "name": "shortageShippingMdl"
    },
    model: {
      value: (_vm.shortageShippingIdMdl),
      callback: function($$v) {
        _vm.shortageShippingIdMdl = $$v
      },
      expression: "shortageShippingIdMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getShortageShipmentListMdl
    }
  }, [_vm._v("\n                          Search")])])], 1)], 1)]), _vm._v(" "), _c('shortage-shipments', {
    attrs: {
      "shortagePendingShipments": _vm.shortageShipmentListMdl
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShortagePaginateMdl),
      expression: "showShortagePaginateMdl"
    }],
    attrs: {
      "page-count": _vm.pageCountForShortageMdl,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getShortagePaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipmentModel('ShortageMdl')
      }
    }
  }, [_vm._v("Close")])])])])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.isShowReprintPopUp),
      callback: function($$v) {
        _vm.isShowReprintPopUp = $$v
      },
      expression: "isShowReprintPopUp"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reprint Sticker")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelReprint
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('h3', [_vm._v("Are you sure you want to reprint the sticker?")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("This action will be tracked and may require an explanation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "table table-response text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v("Select Printer:- ")]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text ml-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "oldPrint",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FlyerBarcode"
    }
  }, [_vm._v(" Print ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "newPrint",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v(" New Print ")])])])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6 pull-left"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.closeModelReprint
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.reprintRequest
    }
  }, [_vm._v("Yes,\n                      Reprint")])])])])])])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.isShowReprintPopUpReprint),
      callback: function($$v) {
        _vm.isShowReprintPopUpReprint = $$v
      },
      expression: "isShowReprintPopUpReprint"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reprint Sticker")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.cancelReprint
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('h3', [_vm._v("You are not authorized to reprint the sticker for this shipment")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Please return to the print page and hand over the shipment to an authorized person.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6 pull-left"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.cancelReprint
    }
  }, [_vm._v("Cancel Reprint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.closeModelReturnToPrintPage
    }
  }, [_vm._v("Return to Print Page ")])])])])])])])])])])], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708b36a3","hasScoped":true}!./src/views/components/RVPPrintLabelInscanv2/RVPPrintLabelInscanv2.component.html
// module id = 1580
// module chunks = 1